// import UXArmyLogo from "../../uxarmy-logo.svg";
import { ErrorBoundary } from "react-error-boundary";
// import { goBackToWebsite } from "../../utills/common";
// import { Button, Result, Image, Typography, Layout } from "antd";
import ErrorPage from "./ErrorPage";

// const { Header, Content } = Layout;
// const { Paragraph, Text } = Typography;

export default function UXErrorBoundary({ children }) {
  function fallbackRender({ error, resetErrorBoundary }) {
    return <ErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />;
  }

  // const FallbackComponent = ({ error }) => {
  //   return (
  //     <Layout>
  //       <Header className='bg-white'>
  //         <Image src={UXArmyLogo} preview={false} />
  //       </Header>

  //       <Content className='bg-white'>
  //         <Result
  //           status='warning'
  //           title='An error occurred'
  //           subTitle={
  //             <Text strong style={{ fontSize: 16 }}>
  //               {error?.message}
  //             </Text>
  //           }
  //           extra={[
  //             <Button type='primary' key='dashboard' onClick={() => goBackToWebsite()}>
  //               Back to Dashboard
  //             </Button>,
  //             <Button key='retry' onClick={() => window.location.reload()}>
  //               Retry
  //             </Button>,
  //           ]}
  //         >
  //           <Paragraph strong style={{ fontSize: 16 }}>
  //             Stack Trace:
  //           </Paragraph>

  //           <pre>{error?.stack}</pre>
  //         </Result>
  //       </Content>
  //     </Layout>
  //   );
  // };

  return <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>;
}
